import { DEFAULT_LOCALE, LANGUAGES, LOCALES } from '@/constants';

export const getLocaleUrlCode = (locale = DEFAULT_LOCALE) => {
  if (locale.toLowerCase() === 'uk') {
    return 'ua';
  }

  return locale.toLowerCase();
};

export const getLocaleUrlPath = (locale = DEFAULT_LOCALE) => {
  if (locale.toLowerCase() === 'ru') {
    return '';
  }

  return `/${getLocaleUrlCode(locale)}`;
};

export const getLocaleInDBFormat = (locale = DEFAULT_LOCALE) => {
  if (!locale) {
    return 'ru';
  }

  if (locale === 'ua') {
    return 'uk';
  }

  return locale;
};

export const getLocaleISOCode = (locale = DEFAULT_LOCALE) => {
  if (locale) {
    return `${locale}-UA`;
  }

  return `ru-UA`;
};

export const getLocaleFromLanguage = (lang) => {
  switch (lang) {
    case LANGUAGES.ru:
      return LOCALES.ru;
    case LANGUAGES.ua:
      return LOCALES.uk;
    default:
      return LOCALES.ru;
  }
};
